export const ROUTES = Object.freeze({
  HOME: "/",
  LEARN: "/learn",
  JOIN: "/join_unflux",
  STORY: "/story",
  THANKS: "/thanks",
  ABOUT: "/about",
  ENROLL: "/productdesign/cohort",
  LEADS: "/leads",
});
